const intercomsTutorial = {
  module: 'intercoms',
  moduleName: 'Intercoms',
  steps: [
    { target: '.page-title', position: 'bottom', title: 'Intercoms', description: 'Manage your video door stations and intercom devices.' },
    { target: '.page-header-actions', position: 'bottom', title: 'Controls', description: 'Dismiss notifications, refresh status, and manage intercom settings.' },
    { target: '.md-page', position: 'top', title: 'Live Events', description: 'Live intercom events and door release controls in one place.' },
  ],
};
export default intercomsTutorial;
